import BasicDomain from "./BasicDomain";

export default class ActivityPicture extends BasicDomain {

    static TYPE_OTHER = 'OTHER';

    static TYPE_BEFORE = 'BEFORE';

    static TYPE_AFTER = 'AFTER';

    static TYPES = [
        ActivityPicture.TYPE_OTHER,
        ActivityPicture.TYPE_BEFORE,
        ActivityPicture.TYPE_AFTER,
    ]

    static TYPE_LABELS = {
        [ActivityPicture.TYPE_OTHER]: 'Other',
        [ActivityPicture.TYPE_BEFORE]: 'Before',
        [ActivityPicture.TYPE_AFTER]: 'After',
    }

    static DEFAULTS = {
        activity: null, // Parse Pointer to `Activity`
        image: null, // Parse.File of the original image
        type: ActivityPicture.TYPE_OTHER, // String for the type of photo (i.e. before, after,..)
        thumbnail: null, // Parse.File of the auto-generated thumbnail
        metadata: null, // File metadata, such as size and name.
    }

    constructor(props) {
        super('ActivityPicture', props, ActivityPicture.DEFAULTS);
    }


    isSavable = () => (
        this.activity != null
        && this.image != null
        && ActivityPicture.TYPES.includes(this.type)
    );
}

global.Parse.Object.registerSubclass('ActivityPicture', ActivityPicture);
